import { render, staticRenderFns } from "./KycList.vue?vue&type=template&id=26950e16&scoped=true&"
import script from "./KycList.vue?vue&type=script&lang=js&"
export * from "./KycList.vue?vue&type=script&lang=js&"
import style0 from "./KycList.vue?vue&type=style&index=0&id=26950e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26950e16",
  null
  
)

export default component.exports